// extracted by mini-css-extract-plugin
export var smallSpinner = "_ra-0";